import React from "react";
import * as H from "history";
import styled, { css } from "styled-components";

import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text";
import Grid from "src/library/components/Hedron";

interface CreateSupportTicketButtonsProps {
  onRaiseTicket: () => void;
  enableRaise: boolean;
  isRaisingLoading: boolean;
  history: H.History;
  hideRaiseButton?: boolean;
}

const CreateSupportTicketButtons: React.ReactFCWithChildren<CreateSupportTicketButtonsProps> = ({
  history, onRaiseTicket, isRaisingLoading, enableRaise, hideRaiseButton = false
}) => {
  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <Wrapper direction="horizontal">
      <Button
        className="left-button"
        $buttonType="plain"
        onClick={handleGoBack}
      >
        <Text style={{ textDecoration: "underline" }}>
          Cancel and go back
        </Text>
      </Button>

      {!hideRaiseButton && (
        <Button
          className="right-button"
          $buttonType="primary"
          background="primaryDark"
          onClick={() => onRaiseTicket()}
          loading={isRaisingLoading}
          disabled={!enableRaise}
        >
          Raise support ticket
        </Button>
      )}
    </Wrapper>
  );
};

const Wrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    justify-content: center;
    align-items: center;
    
    .left-button {
      margin-right: ${theme.spacing.margins.xs};
    }

    .right-button {
      margin-left: ${theme.spacing.margins.xs};
    }
  `}
`;

export default CreateSupportTicketButtons;
